import type { ListenerMiddlewareInstance } from "@reduxjs/toolkit";
import type { AppState } from "Data/Redux/Reducers";
import { selectToken, selectUser } from "Data/Redux/Slices/User";
import { REHYDRATE } from "redux-persist";
import { pusherConnection } from "src/Pusher";

export const appRehydratedListener = (listenerMiddleware: ListenerMiddlewareInstance<AppState>) => {
	listenerMiddleware.startListening(
		{
			type: REHYDRATE,
			effect: async (action, listenerApi) => {
				const state = listenerApi.getState();
				const user = selectUser(state);
				const token = selectToken(state);

				if (user && token) {
					pusherConnection.initializeConnection();
				}
			}
		}
	);
};
